import Component from '@bythepixel/component-loader';

const marqueeAnimationClass = 'section-marquee__track--animate';

export default class Marquee extends Component {
  static selector = '[data-comp-marquee]';
  static loaderPriority = 'in-view';

  constructor(containerEl) {
    super(containerEl);
    this.marqueeTrack = this.$container.querySelector(
      '[data-comp-marquee-track]',
    );
    this.originalSlide = this.marqueeTrack.querySelector(
      '[data-comp-marquee-original-slide]',
    );
    this.forceAnimation = this.$container.dataset.compMarqueeForceAnimation === 'true';
    this.loadedImages = 0;
    this.totalImageWidth = 0;

    // Dependent on variables above
    this.pictures = this.originalSlide.children;

    if (this.pictures.length > 0) {
      this.loadImages();
      this.determineSpeed();
      this.cloneSlide();
    }
  }

  cloneSlide() {
    // Makes sure these two elements have the same width
    this.marqueeTrack.style.width = `${this.originalSlide.scrollWidth}px`;
    this.marqueeTrack.classList.add(marqueeAnimationClass);

    // Clone image slides to create illusion of a seamless loop
    const slideClone = this.originalSlide.cloneNode(true);
    slideClone.setAttribute('data-comp-marquee', 'clone-slide');

    // Insert cloned slide into DOM
    this.marqueeTrack.appendChild(slideClone);
  }

  determineSpeed() {
    const computedStyle = getComputedStyle(this.marqueeTrack);
    let duration = computedStyle.getPropertyValue('--marquee-duration');
    duration = parseInt(duration);

    const multiple = Math.ceil(this.pictures.length / 10);
    const newDuration = duration * multiple;

    this.marqueeTrack.style.setProperty(
      '--marquee-duration',
      `${newDuration}s`,
    );
  }

  loadImages() {
    Array.from(this.pictures).forEach((picture) => {
      const source = picture.children[0];
      const img = picture.children[1];

      if (source && img) {
        const { sizes, srcset } = source;
        img.removeAttribute('loading');
        img.setAttribute('sizes', sizes);
        img.setAttribute('srcset', srcset);
        img.removeAttribute('data-sizes');
        img.removeAttribute('data-srcset');
      }
    });
  }
}
